<div class="overlay-inner-wrapper">
  <header class="header-2 scroll-x">
    <div class="branding">
      <span class="title">
        {{ 'Bauformverwaltung' | mrTranslate }}
      </span>
    </div>
    <div class="header-actions">
      <div class="header-nav">
        <a class="nav-link nav-icon close" (click)="close()">
          <cds-icon shape="times" size="22" [title]="'Schliessen' | mrTranslate" />
        </a>
      </div>
    </div>
  </header>
  <div class="w-100-p padding-10-lr padding-12-tb scroll-y h-60 d-f row gap-25">
    <div class="d-f col">
      <h3 class="nm">{{ 'Objekte / Komponenten' | mrTranslate }}</h3>
      @if (isLoadingTree()) {
        <clr-spinner class="centred" />
      } @else {
        <clr-tree class="flex-1-1-0 scroll-y">
          <clr-tree-node
            *clrRecursiveFor="let item of komponenten(); getChildren: getChildren"
            [(clrExpanded)]="item.expanded">
            <button
              class="clr-treenode-link"
              [class.active]="selectedKomponente() === item"
              (click)="selectedKomponente.set(item)">
              <cds-icon class="fill-black" [shape]="'objekttyp' + item.Icon" size="28" />
              {{ item.Bezeichnung }}
            </button>
          </clr-tree-node>
        </clr-tree>
      }
    </div>
    <div class="d-f col flex-1-1-0">
      @if (isLoadingTable()) {
        <clr-spinner class="centred" />
      } @else if (colLength()) {
        <h3 class="nm">{{ 'Bauform' | mrTranslate }}: {{ selectedKomponente().Bezeichnung }}</h3>

        <div class="btn-group">
          <button type="button" class="btn btn-icon" (click)="openedBauform.set(null); modal.open()">
            <clr-tooltip>
              <cds-icon clrTooltipTrigger shape="plus" />
              <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'lg'">
                {{ 'Neues Feld hinzufügen' | mrTranslate }}
              </clr-tooltip-content>
            </clr-tooltip>
          </button>
        </div>
        <clr-datagrid
          class="datagrid-compact fill-space"
          cdkDropList
          [cdkDropListData]="bauform().rows"
          (cdkDropListDropped)="moveDrop($event)"
          [cdkDropListSortPredicate]="canSortFn">
          <!-- <clr-dg-column class="fixed-cell"/> -->
          @for (column of bauform().columns; track $index) {
            <clr-dg-column [clrDgField]="column.id" [title]="column.id">
              <ng-container
                *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: ['sfeldna', 'tabwert', 'tabwert_id'] }">
                {{ column.id | titlecase }}
              </ng-container>
            </clr-dg-column>
          }
          <ng-template
            clrVirtualScroll
            let-row
            let-index="index"
            [clrVirtualRowsOf]="bauform().rows"
            [clrVirtualRowsTrackBy]="(_, row) => row?.ID">
            @let disableDrag = openedBauform() != null || index < canSortIndex();
            <clr-dg-row
              [clrDgItem]="row"
              cdkDrag
              [cdkDragData]="index"
              [cdkDragDisabled]="disableDrag"
              [class.cursor-move]="!disableDrag">
              <span *cdkDragPreview>{{ row.feldname }}</span>
              <!-- <clr-dg-cell class="fixed-cell">
              @if (!disableDrag) {<cds-icon shape="ellipsis-vertical" size="10" cdkDragHandle/>}
            </clr-dg-cell> -->
              @for (cell of bauform().columns; track $index) {
                @if (cell.id == 'Feldtyp') {
                  <clr-dg-cell>
                    <cds-icon class="inverse-blue" [shape]="'feldtyp' + row.Feldtyp" size="22" />
                  </clr-dg-cell>
                } @else {
                  <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
                }
              }
            </clr-dg-row>
          </ng-template>
          <ng-template [clrIfDetail]="openedBauform()" (clrIfDetailChange)="openedBauform.set($event)">
            <clr-dg-detail>
              <clr-dg-detail-header>
                <div class="d-f gap-5 clr-align-items-end">
                  <cds-icon class="inverse-blue" [shape]="'feldtyp' + openedBauform().Feldtyp" size="22" />
                  {{ openedBauform().Feldname }}
                </div>
              </clr-dg-detail-header>
              <clr-dg-detail-body>
                <ng-container *ngTemplateOutlet="form; context: { mode: 'edit' }" />

                <div class="btn-group margin-48-t">
                  <button type="submit" form="bauform-edit-form" class="btn btn-success" [disabled]="!canSaveBauform()">
                    {{ 'Speichern' | mrTranslate }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-danger"
                    (click)="deleteBauform()"
                    [disabled]="!canDeleteBauform()">
                    {{ 'Löschen' | mrTranslate }}
                  </button>
                  <button type="button" class="btn btn-outline" (click)="openedBauform.set(null)">
                    {{ 'Abbrechen' | mrTranslate }}
                  </button>
                </div>
              </clr-dg-detail-body>
            </clr-dg-detail>
          </ng-template>
          <clr-dg-footer>{{ bauform().rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
        </clr-datagrid>
      }
    </div>
  </div>
</div>

<clr-modal #modal [clrModalClosable]="true">
  <h3 class="modal-title">{{ 'neues Feld anlegen' | mrTranslate }}: {{ selectedKomponente()?.Bezeichnung }}</h3>
  <div class="modal-body">
    <ng-container *ngTemplateOutlet="form; context: { mode: 'neu' }" />
  </div>
  <div class="modal-footer">
    <div class="btn-group margin-10-t">
      <button type="submit" form="bauform-neu-form" class="btn btn-success">
        {{ 'Speichern' | mrTranslate }}
      </button>
      <button type="button" class="btn btn-outline" (click)="modal.close()">
        {{ 'Abbrechen' | mrTranslate }}
      </button>
    </div>
  </div>
</clr-modal>

<ng-template #form let-mode="mode">
  <form
    id="bauform-{{ mode }}-form"
    clrForm
    autocomplete="off"
    class="width100"
    [clrLabelSize]="5"
    style="max-width: 500px"
    [formGroup]="bauformForm"
    (ngSubmit)="bauformForm.valid && saveBauform(modal)">
    @if (mode == 'neu') {
      <clr-select-container>
        <label>
          {{ 'Feldtyp' | mrTranslate }}
          @if (bauformTyp()) {
            <cds-icon class="inverse-blue" [shape]="'feldtyp' + bauformTyp()" size="22" />
          }
        </label>
        <select clrSelect formControlName="feldtyp">
          @for (typ of BAUFORM_TYPEN | keyvalue: null; track typ.value) {
            <option [value]="typ.value">{{ typ.key | mrTranslate }}</option>
          }
        </select>
        <clr-control-error *clrIfError="'required'">
          {{ 'Erforderlich' | mrTranslate }}
        </clr-control-error>
        <clr-control-error *clrIfError="'max'">
          {{ 'Die maximale Anzahl an Spalten ist erreicht' | mrTranslate }}
        </clr-control-error>
      </clr-select-container>
    }
    <clr-input-container>
      <label>{{ 'Feldname' | mrTranslate }}</label>
      <input type="text" clrInput formControlName="feldname" />
      <clr-control-error *clrIfError="'required'">
        {{ 'Erforderlich' | mrTranslate }}
      </clr-control-error>
    </clr-input-container>
    @if (canUsePflichtFeld()) {
      <clr-checkbox-container>
        <clr-checkbox-wrapper>
          <label>{{ 'Pflichtfeld' | mrTranslate }}</label>
          <input type="checkbox" clrToggle formControlName="isPflicht" />
        </clr-checkbox-wrapper>
      </clr-checkbox-container>
    }
    <clr-checkbox-container>
      <clr-checkbox-wrapper>
        <label>{{ 'zeige in Dokumentation' | mrTranslate }}</label>
        <input type="checkbox" clrToggle formControlName="isExport" />
      </clr-checkbox-wrapper>
    </clr-checkbox-container>
    @if (canUseWerteListe()) {
      <clr-checkbox-container>
        <clr-checkbox-wrapper>
          <label>{{ 'Werteliste verwenden' | mrTranslate }}</label>
          <input type="checkbox" clrToggle formControlName="useWerteListe" />
        </clr-checkbox-wrapper>
      </clr-checkbox-container>
    }
    @if (bauformForm.controls.useWerteListe.value) {
      @if (mode == 'edit' && editTabelle()) {
        <button type="button" class="btn btn-sm btn-outline margin-24-t" (click)="isBaseItemModalOpen.set(true)">
          <cds-icon shape="note" />
          {{ 'Wertetabelle verwalten' | mrTranslate }}
        </button>
      }
      @if (canChangeWerteListe()) {
        <clr-combobox-container>
          <label>{{ 'verfügbare Werteliste' | mrTranslate }}</label>
          <clr-combobox formControlName="werteListe">
            <clr-options>
              <clr-option *clrOptionItems="let werteListe of werteListen(); field: 'Name'" [clrValue]="werteListe">
                @let icon = werteListe.Icon ? 'objekttyp' + werteListe.Icon : 'plus';
                <cds-icon class="fill-black" [shape]="icon" size="22" />
                {{ werteListe.Name }}
              </clr-option>
            </clr-options>
          </clr-combobox>
          <!-- <clr-control-helper>{{'' | mrTranslate}}</clr-control-helper> -->
          <clr-control-error *clrIfError="'required'">
            {{ 'Erforderlich' | mrTranslate }}
          </clr-control-error>
        </clr-combobox-container>
      }
    }
  </form>
</ng-template>

<app-baseitems-wrapper [(isModalOpen)]="isBaseItemModalOpen" [route]="editTabelle()" />
